export const URL_TERMS_LINK = 'https://armcare.com/pages/terms-and-conditions-of-participation';
export const URL_POLICY_LINK = 'https://armcare.com/pages/privacy-policy';
export const URL_ARMCARE_FOR_COACHES = 'https://armcare.com/pages/armcare-for-coaches';

export const URL_ACCOUNTABILITY = {
  TRAINING: '/players/accountability/training',
  EXAMS: '/players/accountability/exams',
}
